import React from 'react'
import { IconButton, Stack, Typography } from '@mui/material'
import { J1ActionforwardarrowB, J1LeftarrowC } from '@e3dc-react/icons'
import { useNavigate } from 'react-router-dom'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

/**
 * Component to display a message prompting the user to rotate their phone to landscape orientation.
 */
const RotatePhoneToLandscapeMessage: React.FC = () => {
  const navigate = useNavigate()
  const { t } = useCustomTranslation()

  return (
    <Stack>
      <Stack flexDirection="row" gap={4} alignItems="center">
        <IconButton onClick={() => navigate(-1)}>
          <J1LeftarrowC sx={{ width: '30px', height: '30px', color: 'primary.main' }} />
        </IconButton>
        <Typography variant="h2">{t('ai360.details-page.title')}</Typography>
      </Stack>

      <Stack>
        <Stack sx={{ height: '100vh' }} gap={2} alignItems="center" justifyContent="center" textAlign="center">
          <J1ActionforwardarrowB sx={{ width: '60px', height: '60px', transform: 'rotate(90deg)' }} color="primary" />
          <Typography variant="h2">{t('ai360.details-page.rotate-to-landscape')}</Typography>
          <Typography variant="h4">{t('ai360.details-page.rotate-to-landscape-description')}</Typography>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default RotatePhoneToLandscapeMessage
